<script lang="ts">
  async function contact() {
    const { text } = await (await fetch(`/api/contact-us`)).json();
    document.querySelector("#name").textContent = text;
  }

  let run = true;
  let bannerOptions = ["Enterprise", "Web", "Full-Stack", "App", "Freelance"];
  let activeOption = bannerOptions[0];

  function toggleRun() {
    run = !run;
  }

  setInterval(() => {
    if (!run) return;
    let currentIndex = bannerOptions.indexOf(activeOption);
    currentIndex = (currentIndex + 1) % bannerOptions.length;
    activeOption = bannerOptions[currentIndex];
  }, 2000);
</script>

<main>
  <h1>
    Be The <span class="change-wrapper">
      (
      <ol class="title-change" on:click={toggleRun}>
        {#each bannerOptions as option}
          <li class:active={activeOption == option}>{option}</li>
        {/each}
      </ol>
      )
    </span> Dev
  </h1>
  <h2>Achieve Your Goals - Be The Dev You Want To Be</h2>
  <p>Be The Dev provides coaching plans for all skill levels and goals.</p>
  <p>Coming Soon</p>
  <p>For more info email - justin.john.nelson+btd@gmail.com</p>
</main>

<style>
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  ol {
    list-style: none;
    cursor: pointer;
  }

  .change-wrapper {
    font-size: 2rem;
    vertical-align: middle;
  }

  .title-change {
    display: inline;
  }

  .title-change li {
    display: none;
    width: 13rem;
    text-align: center;
  }

  .title-change li.active {
    display: inline-block;
  }

  main {
    padding: 1rem;
  }

  h1,
  h2,
  p {
    margin-bottom: 2rem;
  }

  h1 {
    font-size: 4em;
    font-weight: 100;
  }

  @media (max-width: 640px) {
    .change-wrapper {
      display: block;
      width: 100%;
      margin-top: 1rem;
      margin-bottom: 1rem;
    }
  }

  @media (min-width: 640px) {
    main {
      max-width: 725px;
      margin: 0 auto;
    }
  }
</style>
